import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue';
import { useBasicStore } from '../../../stores/basic';
import { Message } from 'element-ui';
import { storeToRefs } from 'pinia';
import SvgIcon from '../common/SvgIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const roomLinkDisplay = ref(true);

const basicStore = useBasicStore();
const { roomId } = storeToRefs(basicStore);

const { origin, pathname } = location;

onMounted(() => {
  if ((window as any).__TRTCElectron) {
    roomLinkDisplay.value = false;
  }
})


const inviteLink = computed(() => {
  return `${origin}${pathname}#/admin?roomId=${roomId.value}`;
});

const schemeLink = computed(() => {
  return `tuiroom://joinroom?roomId=${roomId.value}`;
});

function onCopy(value: string | number) {
  navigator.clipboard.writeText(`${value}`);
  Message({
    message: '复制成功',
    type: 'success',
  });
}

return { __sfc: true,roomLinkDisplay, basicStore, roomId, origin, pathname, inviteLink, schemeLink, onCopy, SvgIcon }
}

})